"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguagesArray = void 0;
var getLanguagesArray = function () { return [
    {
        "value": "as",
        "display": "Assamese"
    },
    {
        "value": "bn",
        "display": "Bengali"
    },
    {
        "value": "en",
        "display": "English"
    },
    {
        "value": "gu",
        "display": "Gujarati"
    },
    {
        "value": "hi",
        "display": "Hindi"
    },
    {
        "value": "kn",
        "display": "Kannada"
    },
    {
        "value": "ml",
        "display": "Malayalam"
    },
    {
        "value": "mr",
        "display": "Marathi"
    },
    {
        "value": "or",
        "display": "Odiya"
    },
    {
        "value": "pa",
        "display": "Punjabi"
    },
    {
        "value": "sd",
        "display": "Sindhi"
    },
    {
        "value": "ta",
        "display": "Tamil"
    },
    {
        "value": "te",
        "display": "Telugu"
    },
    {
        "value": "ur",
        "display": "Urdu"
    }
]; };
exports.getLanguagesArray = getLanguagesArray;
